//get url parameter
function getUrlParameter(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

// Changes icon for Collapsible Sections on click
jQuery('.ilab-child-report .collapse').on('shown.bs.collapse', function(){
  jQuery(this).parent().find("i").removeClass("fa fa-angle-right").addClass("fa fa-angle-down").css("transition: 0.2s all ease-in-out;");
}).on('hidden.bs.collapse', function(){
  jQuery(this).parent().find("i").removeClass("fa fa-angle-down").addClass("fa fa-angle-right");
});

jQuery(function() {
  jQuery('.ilab-child-report .collapse').click(function () {
    jQuery('i').css({
      'transition': 'all .2s ease-in-out'
    });
    jQuery('i').css({
      'transition': 'all .2s ease-in-out'
    });
  });
});

//ILAB Child Labor Report Country Browse Location Changes
var ilabSelectCountry = jQuery("#ilab-select--country");
var ilabChildLaborReportCountry = jQuery("#ilab-child-labor-report-country");
if (ilabChildLaborReportCountry.length || ilabSelectCountry.length) {
  jQuery("#ilab-select--country, #ilab-child-labor-report-country").on("change", function() {
    location = this.options[this.selectedIndex].value;
  });
}

// Wrapped in Drupal.behaviors so that jQuery can work after ajax call
(function ($, Drupal, once) {
  Drupal.behaviors.descriptionExpand = {
    attach: function (context, settings) {
      // Index Page description show/hide
      $(once('descriptionExpand', '.arrowcontainer', context)).on('click', function (e) {
        e.preventDefault();
        var descriptor = jQuery(this).parent().parent().parent().find('.ilab-summary-div');
        if (descriptor.length > 0) {
          $(descriptor).toggleClass('active');
          $(this).find('.svg-inline--fa').toggleClass('fa-chevron-right fa-chevron-down');
        }
      });
      $(once('descriptionExpand', '.arrowcontainer', context)).on('keydown', function (e) {
        if (e.keyCode == 13) {
          var descriptor = $(this).parent().parent().parent().find('.ilab-summary-div');
          if (descriptor.length > 0) {
            $(descriptor).toggleClass('active');
            $(this).find('.svg-inline--fa').toggleClass('fa-chevron-right fa-chevron-down');
          }
        }
      });
    }
  };
})(jQuery, Drupal, once);


jQuery(function() {
    // Open filter box when being used
    // Projects
    var field_ilab_region_target_id = getUrlParameter('field_ilab_region_target_id');
    var field_project_ilab_project_reg_target_id = getUrlParameter('field_project_ilab_project_reg_target_id');
    var field_project_grantee_target_id = getUrlParameter('field_project_grantee_target_id');
    var field_office_target_id = getUrlParameter('field_office_target_id');
    var active_select = getUrlParameter('active_select');
    var active_on_date = getUrlParameter('active_on_date');
    var active_from_date = getUrlParameter('active_from_date');
    var active_to_date = getUrlParameter('active_to_date');
    // Flagged as an unused varaiable by SonarQube June 2023
    //var funded_select = getUrlParameter('funded_select');
    var field_fiscal_year_value = getUrlParameter('field_fiscal_year_value');
    var funded_from_year = getUrlParameter('funded_from_year');
    var funded_to_year = getUrlParameter('funded_to_year');
    // Research
    var research_from_year_published = getUrlParameter('research_from_year_published');
    var research_to_year_published = getUrlParameter('research_to_year_published');
    var field_research_region_target_id = getUrlParameter('field_research_region_target_id');
    var field_research_type_target_id = getUrlParameter('field_research_type_target_id');
    var field_country_target_id = getUrlParameter('field_country_target_id');
    var field_officesearch_target_id = getUrlParameter('field_officesearch_target_id');
    // Goods / Products
    var field_region_collection_target_id = getUrlParameter('field_region_collection_target_id');
    var field_ilab_good_target_id = getUrlParameter('field_ilab_good_target_id');
    var field_exp_good_target_id = getUrlParameter('field_exp_good_target_id');
    var field_tid = getUrlParameter('tid');
    var field_exp_exploitation_type_target_id_1 = getUrlParameter('field_exp_exploitation_type_target_id_1');

    // Submissions
    var field_related_report_abbre_target_id = getUrlParameter('field_related_report_abbre_target_id');
    // NAALC
    var field_naalc_office_target_id = getUrlParameter('field_naalc_office_target_id');
    var field_status_target_id = getUrlParameter('field_status_target_id');
    var field_issue_target_id = getUrlParameter('field_issue_target_id');
    // Performance
    var field_evaluation_type_target_id = getUrlParameter('field_evaluation_type_target_id');

    if ((field_evaluation_type_target_id != 'All' && field_evaluation_type_target_id != '')) {
        jQuery('.show-hide-filters').click();
    }

    if ((field_research_type_target_id != 'All' && field_research_type_target_id != '') ||
        (field_country_target_id != 'All' && field_country_target_id != '') ||
        (field_officesearch_target_id != 'All' && field_officesearch_target_id != '') ||
        (field_research_region_target_id != 'All' && field_research_region_target_id != '') ||
        (research_from_year_published != 'All' && research_from_year_published != '') ||
        (research_to_year_published != 'All' && research_to_year_published != '')) {
        jQuery('.show-hide-filters').click();
    }

    if ((field_ilab_region_target_id != 'All' && field_ilab_region_target_id != '') ||
        (field_project_ilab_project_reg_target_id != 'All' && field_project_ilab_project_reg_target_id != '') ||
        (field_office_target_id != 'All' && field_office_target_id != '') ||
        (field_project_grantee_target_id != 'All' && field_project_grantee_target_id != '') ||
        active_on_date != '' || active_from_date != '' || active_to_date != '' ||
        (field_fiscal_year_value != 'All' && field_fiscal_year_value != '') ||
        (funded_from_year != 'All' && funded_from_year != '') ||
        (funded_to_year != 'All' && funded_to_year != '')) {
        jQuery('.show-hide-filters').click();
    }


    if ((field_related_report_abbre_target_id != 'All' && field_related_report_abbre_target_id != '') ||
        (field_naalc_office_target_id != 'All' && field_naalc_office_target_id != '')  ||
        (field_status_target_id != 'All' && field_status_target_id != '')  ||
        (field_issue_target_id != 'All' && field_issue_target_id != '')) {
        jQuery('.show-hide-filters').click();
    }

    if ((field_region_collection_target_id != 'All' && field_region_collection_target_id != '') ||
        (field_ilab_good_target_id != 'All' && field_ilab_good_target_id != '')  ||
        (field_exp_exploitation_type_target_id_1 != 'All' && field_exp_exploitation_type_target_id_1 != '') ||
        (field_tid != 'All' && field_tid != '') ||
        (field_exp_good_target_id != 'All' && field_exp_good_target_id != '')) {
            jQuery('.show-hide-filters').click();
    }

    // Show filter if it's being used.
    if ((funded_from_year !== '' && funded_from_year !== 'All') || (funded_to_year !== '' && funded_to_year !== 'All') ) {
        jQuery('.projects-ilab-index-block .fiscal-year-value-filter-div').hide();
        jQuery('.projects-ilab-index-block .funded-to-form-year-filter-div').show();
    }
    if ((active_on_date !== null && active_on_date !== '') || active_select == 'on') {
        jQuery('.projects-ilab-index-block .active-on-date-filter-div').show();
        jQuery('.projects-ilab-index-block .active-to-form-date-filter-div').hide();
    }

    // Submit Show Item filter change on ILAB tables
    // Necessary after removing AJAX
    jQuery( "#views-exposed-form-ilab-list-of-products2-list-of-products-ilab-index-view-page2 #edit-items-per-page,#views-exposed-form-ilab-list-of-goods2-list-of-goods-ilab-index-view-page2 #edit-items-per-page,#views-exposed-form-ilab-research-research-ilab-topics-index-view-page #edit-items-per-page, #views-exposed-form-ilab-research-research-ilab-keywords-index-view-page #edit-items-per-page, #views-exposed-form-ilab-index-pages-projects-ilab-keywords-index-view-page #edit-items-per-page, #views-exposed-form-ilab-index-pages-projects-ilab-topics-index-view-page #edit-items-per-page, #views-exposed-form-ilab-index-pages-projects-ilab-index-view-page #edit-items-per-page, #views-exposed-form-ilab-research-research-ilab-index-view-page #edit-items-per-page, #views-exposed-form-ilab-list-of-goods-list-of-goods-ilab-index-view-page #edit-items-per-page, #views-exposed-form-ilab-list-of-products-list-of-products-ilab-index-view-page #edit-items-per-page, #views-exposed-form-ilab-naalc-naalc-ilab-index-view-page #edit-items-per-page, #views-exposed-form-ilab-performance-monitoring-performance-monitoring-ilab-index-view-page #edit-items-per-page, #views-exposed-form-ilab-submission-submission-ilab-index-view-page #edit-items-per-page" ).change(
        function() {
            jQuery('.ilab-index-page-filter-form').submit();
        }
    );
});


// Project Index Page Active Filter
jQuery(function() {
    jQuery( "#edit-active-select--2, #edit-active-select" ).change(function() {
        var active_select_value = jQuery(this).val();
        if (active_select_value == 'on') {
            jQuery('.projects-ilab-index-block .active-to-form-date-filter-div').hide();
            jQuery('input[name=active_from_date]').val("");
            jQuery('input[name=active_to_date]').val("");
            jQuery('input[name=active_on_date]').val("");
            jQuery('.projects-ilab-index-block .active-on-date-filter-div').show();
        }
        if (active_select_value == 'between') {
            jQuery('.projects-ilab-index-block .active-on-date-filter-div').hide();
            jQuery('input[name=active_from_date]').val("");
            jQuery('input[name=active_to_date]').val("");
            jQuery('input[name=active_on_date]').val("");
            jQuery('.projects-ilab-index-block .active-to-form-date-filter-div').show();
        }
    });

    jQuery( "#edit-funded-select--2, #edit-funded-select" ).change(function() {
        var funded_select_value = jQuery(this).val();
        if (funded_select_value == 'infiscalyears') {
            jQuery('.projects-ilab-index-block .funded-to-form-year-filter-div').hide();
            $("#select[name=funded_from_year] option[value=0]").attr('selected', 'selected');
            jQuery('select[name=funded_to_year]').val("All");
            jQuery('select[name=field_fiscal_year_value]').val("All");
            jQuery('.projects-ilab-index-block .fiscal-year-value-filter-div').show();
        }
        if (funded_select_value == 'betweenfiscalyears') {
            jQuery('.projects-ilab-index-block .fiscal-year-value-filter-div').hide();
            $("#select[name=funded_from_year] option[value=0]").attr('selected', 'selected');
            jQuery('select[name=funded_to_year]').val("All");
            jQuery('select[name=field_fiscal_year_value]').val("All");
            jQuery('.projects-ilab-index-block .funded-to-form-year-filter-div').show();
        }
    });
});

var checkMobile = function () {
    // dPosition = getCoords(ele_h3).top - sPosition;
    if (window.innerWidth < 500 && dPosition != undefined) {
        document.querySelector('.carousel-control-prev').setAttribute('style', "top:" + dPosition + "px");
        document.querySelector('.carousel-control-next').setAttribute('style', "top:" + dPosition + "px");
    }
};

jQuery('#ilab-project-print').click(function(){
    window.print();
});

// Closes navigation off click
jQuery(document).mouseup(function(e) {
    var nav_wrapper = jQuery(".cd-primary-nav");

    if (!nav_wrapper.is(e.target) && nav_wrapper.has(e.target).length === 0) {
        // jQuery(".cd-secondary-nav").addClass('is-hidden');
        jQuery('.cd-primary-nav .has-children a').removeClass('selected');
        jQuery('.cd-secondary-nav').addClass('is-hidden');
    }
});

jQuery(document).ready(function() {
    jQuery('<div class="arrow-down"></div>').insertAfter('.has-arrow');
    jQuery('<div class="arrow-down-research"></div>').insertAfter('.research-arrow');

    // Hide and show the description on Projects Document Search view
    jQuery(".ilab-doc-search-show").hide();
    jQuery(".ilab-doc-search-toggle").click(function(){
        var txt = jQuery(this).text();
        txt = (txt !='Show Description') ? 'Show Description' : 'Hide Description';
        jQuery(this).text(txt);
        jQuery(this).next().toggle('.ilab-doc-search-show');
     });

     // Move the Items per Page in exposed filters to a different div
     //jQuery(".ilab-search-filters .js-form-item.form-item.js-form-type-select.form-item-items-per-page.js-form-item-items-per-page").appendTo(".ilab-search-row header");
});


(function ($) {
    $("#east-asia-pacific").mouseenter(function(){
        $("span.world-map-hover").hide();
        $("span#eap").show();
    }).mouseleave(function(){
        $("span#eap").hide();
    });
    $("#south-central-asia").mouseenter(function(){
        $("span.world-map-hover").hide();
        $("span#sca").show();
    }).mouseleave(function(){
        $("span#sca").hide();
    });
    $("#europe-eurasia").mouseenter(function(){
        $("span.world-map-hover").hide();
        $("span#europe").show();
    }).mouseleave(function(){
        $("span#europe").hide();
    });
    $("#americas").mouseenter(function(){
        $("span.world-map-hover").hide();
        $("span#lac").show();
    }).mouseleave(function(){
        $("span#lac").hide();
    });
    $("#middle-east-north-africa").mouseenter(function(){
        $("span.world-map-hover").hide();
        $("span#mena").show();
    }).mouseleave(function(){
        $("span#mena").hide();
    });
    $("#sub-saharan-africa").mouseenter(function(){
        $("span.world-map-hover").hide();
        $("span#africa").show();
    }).mouseleave(function(){
        $("span#africa").hide();
    });

    $(".ilab-around-world #east-asia-pacific").click(function(){
        window.location = "/agencies/ilab/region/east-asia-pacific";
    });
    $(".ilab-around-world #south-central-asia").click(function(){
        window.location = "/agencies/ilab/region/south-central-asia";
    });
    $(".ilab-around-world #europe-eurasia").click(function(){
        window.location = "/agencies/ilab/region/europe-eurasia";
    });
    $(".ilab-around-world #americas").click(function(){
        window.location = "/agencies/ilab/region/americas";
    });
    $(".ilab-around-world #middle-east-north-africa").click(function(){
        window.location = "/agencies/ilab/region/middle-east-north-africa";
    });
    $(".ilab-around-world #sub-saharan-africa").click(function(){
        window.location = "/agencies/ilab/region/sub-saharan-africa";
    });

    $(".ilab-findings #east-asia-pacific").click(function(){
        window.location = "/agencies/ilab/resources/reports/child-labor/east-asia-pacific";
    });
    $(".ilab-findings #south-central-asia").click(function(){
        window.location = "/agencies/ilab/resources/reports/child-labor/south-central-asia";
    });
    $(".ilab-findings #europe-eurasia").click(function(){
        window.location = "/agencies/ilab/resources/reports/child-labor/europe-eurasia";
    });
    $(".ilab-findings #americas").click(function(){
        window.location = "/agencies/ilab/resources/reports/child-labor/americas";
    });
    $(".ilab-findings #middle-east-north-africa").click(function(){
        window.location = "/agencies/ilab/resources/reports/child-labor/middle-east-north-africa";
    });
    $(".ilab-findings #sub-saharan-africa").click(function(){
        window.location = "/agencies/ilab/resources/reports/child-labor/sub-saharan-africa";
    });
})(jQuery);

// This will allow the ilab dropdown to always have the current country selected
(function ($) {
    var currentCountry = $("h3.ilab-country-title").text().trim();
    var selectedCountry = $('.ilab-countries-dropdown select option').filter(function () {
        return $(this).text() == currentCountry;
    }).val();
    $('.ilab-countries-dropdown select').val(selectedCountry);
    // Doing the same for the ilab country pages
    var currentLandingCountry = $('span#country-landing-name').text().trim();
    var selectedLandingCountry = $('.ilab-countries-dropdown select option').filter(function () {
        return $(this).text() == currentLandingCountry;
    }).val();
    $('.ilab-countries-dropdown select').val(selectedLandingCountry);
})(jQuery);


// Enforces DatePicker in ILAB Index Pages using jQuery
jQuery(document).ready(function () {
    jQuery('#ilab_active_on_date').datepicker();
    jQuery('#ilab_active_to_date').datepicker();
    jQuery('#ilab_active_from_date').datepicker();
});
